import { ApiPhoneExtension } from '../types/PhoneExtension';

let serviceWorkerRegistration: ServiceWorkerRegistration | null = null;

export const init = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register('./service-worker.js')
      .then((registration) => {
        serviceWorkerRegistration = registration;
      })
      .catch(console.error);
  }
};

export const focusWindow = () => {};

export const requestNotificationPermissions = () => {
  if ('Notification' in window) {
    Notification.requestPermission().catch(() => {});
  }
};

const activeNotifications = new Map<string, Notification>();

export const notify = (
  id: string | undefined,
  title: string,
  _description: string,
  params: { icon?: string; timeout?: number },
) => {
  if (!('Notification' in window) || Notification.permission !== 'granted')
    return;

  const { icon, timeout } = params;

  try {
    const notification = new Notification(title, {
      tag: id,
      icon,
    });

    if (id) {
      activeNotifications.set(id, notification);
      notification.onclose = () => activeNotifications.delete(id);
    }

    if (timeout) {
      setTimeout(() => {
        notification.close();
      }, timeout * 1000);
    }
  } catch (_e) {
    // Some mobile browsers require service worker for notifications
    if (serviceWorkerRegistration) {
      serviceWorkerRegistration
        .showNotification(title, {
          tag: id,
          icon,
        })
        .catch(() => {});
    }
  }
};

export const closeNotification = (id: string) => {
  const notification = activeNotifications.get(id);
  if (notification) {
    notification.close();
  } else if (serviceWorkerRegistration && id) {
    serviceWorkerRegistration
      .getNotifications({ tag: id })
      .then((notifications) => {
        notifications.forEach((n) => n.close());
      });
  }
};

export const vcrmAvailability = (_isAvailable: boolean) => {};

export const vcrmConnection = (_status: {
  isRegistering?: boolean;
  isRegistered?: boolean;
}) => {};

export const hasLoggedIn = (
  _accessToken: string,
  _user: any,
  _teams: any,
) => {};

export const hasLoggedOut = () => {};

export const hasSelectedTeam = (_customerId: string) => {};

export const hasSelectedExtension = (_extension: ApiPhoneExtension) => {};

export const setRequestReferer = (_referer: string) => {};

export const shutdownComplete = () => {};

export const openInExternalBrowser = (_url: string) => {};
